module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jFkkB"))).then(() => module.bundle.root('ewmtE'));